import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Switch, Route } from 'react-router-dom';
import { Subheader, Tab, ActiveTab } from '@layout/Subheader';
import { PageTemplate } from '@templates';
import UsersManager from './UsersManager';
import IntroMessages from './IntroMessages.container';
import messages from './messages';

// TODO: #600 Remove code duplicate for Subheader
const AdminSubheader = () => (
  <Switch>
    <Route exact path="/admin">
      <Subheader>
        <ActiveTab>
          <FormattedMessage {...messages.usersManager} />
        </ActiveTab>
        <Tab to="/admin/intro-messages">
          <FormattedMessage {...messages.introMessages} />
        </Tab>
      </Subheader>
    </Route>
    <Route path="/admin/intro-messages">
      <Subheader>
        <Tab to="/admin">
          <FormattedMessage {...messages.usersManager} />
        </Tab>
        <ActiveTab>
          <FormattedMessage {...messages.introMessages} />
        </ActiveTab>
      </Subheader>
    </Route>
  </Switch>
);

export const AdminPage = () => (
  <PageTemplate
    title={<FormattedMessage {...messages.header} />}
    subheader={<AdminSubheader />}
  >
    <Switch>
      <Route exact path="/admin" component={UsersManager} />
      <Route exact path="/admin/intro-messages" component={IntroMessages} />
    </Switch>
  </PageTemplate>
);



// WEBPACK FOOTER //
// ./components/pages/AdminPage/AdminPage.js